import { useEffect, useMemo } from 'react'
import { useMqttStore } from 'store/mqtt'

import TrackingMap from 'components/TrackingMap'
import { useLiveTrackingTruckStore } from 'store/liveTrackingTruck'
import useReceiveMessage from 'hooks/useReceiveMessage'
import { ActionPostMessageEnum } from 'constants/postMessage'
import FlyMapTo from 'components/TrackingMap/FlyMapTo'
import { RestrictedWebview } from 'components/WebViewSession'
import { getTokenCookies } from 'utils/cookie'

import Content, { centroidPosition } from './Content'
import type { LatLngPositionType, ReceiveMessageTruckUserData } from './type'

const LiveTrackingTruck = () => {
  const {
    isAuthorized: isMqttAuthorized,
    connectStatus,
    mqttSubcribe,
  } = useMqttStore()

  const { userData, setUserData } = useLiveTrackingTruckStore()
  const token = getTokenCookies()

  useReceiveMessage<ReceiveMessageTruckUserData>(
    ActionPostMessageEnum.SET_USER_DATA,
    (data) => {
      const payload = {
        userId: data.payload.userId,
        username: `admin_${data.payload.userId}`,
        auth: data.payload.auth,
        locations: data.payload.locations,
      }
      setUserData(payload)
    }
  )

  // subscribe MQTT topic per lokasi yang dipilih
  useEffect(() => {
    if (
      connectStatus === 'Connected' &&
      userData &&
      userData.locations.length > 0
    ) {
      const { username } = userData
      userData.locations.forEach((loc) => {
        mqttSubcribe({
          username,
          topic: `location/hub/${loc.id}/truck/+`,
          qos: 0,
        })
      })
    }
  }, [connectStatus, mqttSubcribe, userData])

  // center peta = centroid dari semua lokasi yang dipilih
  const mapCenter = useMemo((): LatLngPositionType => {
    if (!userData || userData.locations.length === 0) return centroidPosition

    const latSum = userData.locations.reduce(
      (sum, loc) => sum + parseFloat(loc.latitude),
      0
    )
    const lonSum = userData.locations.reduce(
      (sum, loc) => sum + parseFloat(loc.longitude),
      0
    )
    const count = userData.locations.length

    return [latSum / count, lonSum / count]
  }, [userData])

  if (!token || !isMqttAuthorized) {
    return <RestrictedWebview />
  }

  return (
    <TrackingMap
      apiKey={process.env.REACT_APP_MAPS_KEY_LIVE_TRACKING_DRIVER || ''}
      className="live-tracking-truck"
      mqttUsername={userData?.username}
      mqttPassword={userData?.auth}
      hubId={userData?.locations[0]?.id}
      center={mapCenter}
      zoom={13}
      usePmtiles
    >
      {/* only fly to Monas placeholder before userData is received;
          once userData is set, Content handles fitBounds to all hubs */}
      {!userData && <FlyMapTo position={mapCenter} zoom={13} />}
      <Content />
    </TrackingMap>
  )
}

export default LiveTrackingTruck
